function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import Decimal from "decimal.js";
import { NumberCommonUtils } from "trade_utils_lib";
import ExchangeDataProvider from "../TradeLib/ExchangeDataProvider";
import { $stn } from "./i18n";
import { getCurrentLocale, Locale } from "./LocaleConfig";
var DECIMAL_100 = new Decimal(100);
var NumberUtils = /*#__PURE__*/function () {
  function NumberUtils() {
    _classCallCheck(this, NumberUtils);
  }
  _createClass(NumberUtils, null, [{
    key: "toPercentNum",
    value: function toPercentNum(val) {
      try {
        return new Decimal(val).toDecimalPlaces(2, Decimal.ROUND_DOWN).toNumber();
      } catch (e) {
        return 0;
      }
    }
  }, {
    key: "effectiveDecimal",
    value: function effectiveDecimal(value) {
      var decimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var rounding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Decimal.ROUND_DOWN;
      return NumberCommonUtils._inner_EffectiveDecimal(value, decimal, rounding).toString();
    }
  }, {
    key: "effectiveDecimalNum",
    value: function effectiveDecimalNum(value) {
      var decimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var rounding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Decimal.ROUND_DOWN;
      if (!value) {
        return 0;
      }
      return NumberCommonUtils._inner_EffectiveDecimal(value, decimal, rounding).toNumber();
    }
  }, {
    key: "toPrice",
    value: function toPrice(value, pair) {
      var rounding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Decimal.ROUND_DOWN;
      var symbol = ExchangeDataProvider.getExchangeSymbol(pair);
      var precision = 4;
      if (symbol) {
        precision = symbol.precision !== undefined ? symbol.precision : 4;
      }
      return NumberCommonUtils._inner_EffectiveDecimal(value, precision, rounding).toString();
    }
  }, {
    key: "toAmount",
    value: function toAmount(value, pair) {
      var rounding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Decimal.ROUND_DOWN;
      var symbol = ExchangeDataProvider.getExchangeSymbol(pair);
      var precision = 4;
      if (symbol) {
        precision = symbol.amount !== undefined ? symbol.amount : 4;
      }
      return NumberCommonUtils._inner_EffectiveDecimal(value, precision, rounding).toString();
    }

    /**
     * @deprecated since "Mon May 18 2020 11:43:35 GMT+0800 (中国标准时间)"
     * Replaced by NumberTradeUtils.ts
     */
  }, {
    key: "toPriceBySymbol",
    value: function toPriceBySymbol(value, symbol) {
      var rounding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Decimal.ROUND_DOWN;
      var precision = symbol.precision !== undefined ? symbol.precision : 4;
      return NumberCommonUtils._inner_EffectiveDecimal(value, precision, rounding).toString();
    }

    /**
     * @deprecated since "Mon May 18 2020 11:43:35 GMT+0800 (中国标准时间)"
     * Replaced by NumberTradeUtils.ts
     */
  }, {
    key: "toAmountBySymbol",
    value: function toAmountBySymbol(value, symbol) {
      var rounding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Decimal.ROUND_DOWN;
      var precision = symbol.amount !== undefined ? symbol.amount : 4;
      return NumberCommonUtils._inner_EffectiveDecimal(value, precision, rounding).toString();
    }

    /**
     * @deprecated since "Mon May 18 2020 11:43:35 GMT+0800 (中国标准时间)"
     * Replaced by NumberTradeUtils.ts
     */
  }, {
    key: "toPriceNumBySymbol",
    value: function toPriceNumBySymbol(value, symbol) {
      var rounding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Decimal.ROUND_DOWN;
      var precision = symbol.precision !== undefined ? symbol.precision : 4;
      if (!value) {
        return 0;
      }
      return NumberCommonUtils._inner_EffectiveDecimal(value, precision, rounding).toNumber();
    }

    /**
     * @deprecated since "Mon May 18 2020 11:43:35 GMT+0800 (中国标准时间)"
     * Replaced by NumberTradeUtils.ts
     */
  }, {
    key: "toAmountNumBySymbol",
    value: function toAmountNumBySymbol(value, symbol) {
      var rounding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Decimal.ROUND_DOWN;
      var precision = symbol.amount !== undefined ? symbol.amount : 4;
      if (!value) {
        return 0;
      }
      return NumberCommonUtils._inner_EffectiveDecimal(value, precision, rounding).toNumber();
    }
  }, {
    key: "toShortString",
    value: function toShortString(value) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      try {
        if (value) {
          var valueDecimal = new Decimal(value);
          if (getCurrentLocale() === Locale.zhCN) {
            if (valueDecimal.greaterThanOrEqualTo(100000000)) {
              var num = Decimal.round(valueDecimal.div(new Decimal(1000000))).div(DECIMAL_100);
              if (format) {
                return $stn(num.toNumber()) + "亿";
              }
              return num + "亿";
            } else if (valueDecimal.greaterThanOrEqualTo(10000)) {
              var _num = Decimal.round(valueDecimal.div(new Decimal(100))).div(DECIMAL_100);
              if (format) {
                return $stn(_num.toNumber()) + "万";
              }
              return _num + "万";
            } else {
              var _num2 = Decimal.round(valueDecimal.mul(DECIMAL_100)).div(DECIMAL_100);
              if (format) {
                return $stn(_num2.toNumber());
              }
              return _num2.toString();
            }
          } else {
            if (valueDecimal.greaterThanOrEqualTo(1000000000000)) {
              var _num3 = Decimal.round(valueDecimal.div(new Decimal(10000000000))).div(DECIMAL_100);
              if (format) {
                return $stn(_num3.toNumber()) + "T";
              }
              return _num3 + "T";
            } else if (valueDecimal.greaterThanOrEqualTo(1000000000)) {
              var _num4 = Decimal.round(valueDecimal.div(new Decimal(10000000))).div(DECIMAL_100);
              if (format) {
                return $stn(_num4.toNumber()) + "B";
              }
              return _num4 + "B";
            } else if (valueDecimal.greaterThanOrEqualTo(1000000)) {
              var _num5 = Decimal.round(valueDecimal.div(new Decimal(10000))).div(DECIMAL_100);
              if (format) {
                return $stn(_num5.toNumber()) + "M";
              }
              return _num5 + "M";
            } else if (valueDecimal.greaterThanOrEqualTo(1000)) {
              var _num6 = Decimal.round(valueDecimal.div(new Decimal(10))).div(DECIMAL_100);
              if (format) {
                return $stn(_num6.toNumber()) + "K";
              }
              return _num6 + "K";
            } else {
              var _num7 = Decimal.round(valueDecimal.mul(DECIMAL_100)).div(DECIMAL_100);
              if (format) {
                return $stn(_num7.toNumber());
              }
              return _num7.toString();
            }
          }
        } else {
          return "0";
        }
      } catch (e) {
        return "0";
      }
    }
  }, {
    key: "toPreFix",
    value: function toPreFix(value, n) {
      if ("".concat(value).length >= n) {
        return "".concat(value);
      }
      return "".concat(Array(n).join("0")).concat(value).slice(-n);
    }
  }]);
  return NumberUtils;
}();
export { NumberUtils as default };